import { is, where } from 'ramda'
import { isValidElement } from 'react'
import { createGlobalState } from 'react-use'

const useGlobalMessageState = createGlobalState(new Set())

const useMessages = () => {
  const [messages, setMessages] = useGlobalMessageState()
  const addMessage = (message) => {
    // Message schema validation
    if (
      where(
        {
          id: is(String),
          node: isValidElement
        },
        message
      )
    ) {
      setMessages(messages.add(message))
    } else {
      // eslint-disable-next-line no-console
      console.warn('Invalid message')
    }
  }
  const removeMessage = (id) => {
    const msgToBeDeleted = [...messages].find((m) => m.id === id)
    if (msgToBeDeleted) {
      messages.delete(msgToBeDeleted)
    }
  }
  return { addMessage, removeMessage, messages: [...messages] }
}

export default useMessages
